import React from 'react';
import { useStyles } from '../styles';
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Slide,
  Typography,
} from "@material-ui/core";
import CurrencySymbol from './CurrencySymbol';

export default function ProductList(props) {
  const styles = useStyles();
  let selCatId = props.selectedCat.id;
  console.log(props.categories)
  let adOnCats = [];
  let userSets = props.userInfo;
  console.log(userSets);
  props.categories.filter(cat => cat.isAddOn && adOnCats.push(cat.id));
  console.log(adOnCats);
  return (
    <Grid container spacing={1} id="pro_continer">
      {props.items?.filter(pro => (
        (!props.selectedCat && adOnCats.indexOf(pro.category) == -1)
        ||
        (pro.category == selCatId)) && pro.inStock).map(it => {
          return (<Grid item xs={6} sm={6} md={4}>
            <Card
              className={styles.card}
              onClick={() => props.productClickHandler(it)}
              style={{ width: 'auto', backgroundColor: userSets.themeColor, color: userSets.themeTxtColor }}
            >
              <CardMedia
                component="img"
                image={it.image}
                className={styles.media}
                onError={props.imageOnErrorHandler}
              />

              {false && it["cat_type"] ?
                <div className={styles.veg_img}>
                  <img
                    src={it.cat_type.toUpperCase() === "VEG" ? "/images/veg.png" : "/images/Non-veg.png"}
                    width="30px"
                    height="30px"
                  />
                </div> : " "
              }

              <CardContent className={styles.cardFooter} style={{ color: userSets.themeTxtColor }}>
                <Box className={styles.foot}>
                  <div
                    className={styles.prod_title}
                    fontSize="1em"
                    style={{ fontSize: "0.8em", color: userSets.themeTxtColor }}
                  >
                    {it.name}
                  </div>
                  {it.price ?
                    <div className="pro_price">
                      <h3 style={{ margin: "0px", color: userSets.themeTxtColor }}>
                        <CurrencySymbol />{it.price}
                      </h3>
                    </div>
                    :
                    ""
                  }
                </Box>
              </CardContent>
            </Card>
          </Grid>
          )
        })}

    </Grid>
  );
}
